module.exports = __webpack_public_path__ + "static/media/Default Effect.d53ef298.jpg";